import getEnv from '../env/enviroment';
import { SEGMENT_PRODUCT_NAME } from '../constants/constants';

declare global {
  interface Window {
    // hold segments analytics
    analytics: any;
    prevPath: string | null;
  }
}
window.analytics = window.analytics || {};

export default class Analytics {
  static env = getEnv();
  static init() {
    if (this.env.segment_api_key) {
      window.analytics._writeKey = this.env.segment_api_key;
      window.analytics.load(this.env.segment_api_key);
      this.trackCurrentPage(window.location.pathname);
    }
  }

  static trackCurrentPage(pathname: string, applicationId = '') {
    if (this.env.segment_api_key && pathname !== window.prevPath) {
      // Need to use prevPath as the referrer due to SPA setup with Segment
      // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/single-page-apps/
      const referrer = window.prevPath ? `${window.location.origin}${window.prevPath}` : window.location.origin;
      window.analytics.page({
        product: SEGMENT_PRODUCT_NAME,
        referrer,
        application_id: applicationId
      });
      window.prevPath = pathname ?? '';
    }
  }

  static trackEvent(eventName: string, payload: any) {
    if (this.env.segment_api_key) {
      window.analytics.track(eventName, payload);
    }
  }
}
